import { useSelector } from "react-redux";
import { State } from "../../../../state/store";
import { User } from "../../../../domain/user/User";
import { UserId } from "../../../../domain/user/UserId";
import { UserEmail } from "../../../../domain/user/UserEmail";
import { UserName } from "../../../../domain/user/UserName";
import { getUserAccountRoleFromValue } from "../../../../domain/user/account/UserAccountRole";

export const useUserList = (): User[] | null => {
    const responseJson = useSelector((state: State) => state.adminUser.users);

    return responseJson ? responseJson.map(user => User.from(
        UserId.fromString(user.id),
        UserName.fromString(user.name),
        UserEmail.fromString(user.email),
        getUserAccountRoleFromValue(user.role)
    )) : null;
};
